import { render, staticRenderFns } from "./order-edit.vue?vue&type=template&id=7c09fb38&scoped=true&"
import script from "./order-edit.vue?vue&type=script&lang=js&"
export * from "./order-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c09fb38",
  null
  
)

export default component.exports